module.exports = __webpack_public_path__ + "img/zrx.bd8c8c30.svg";